import { render } from "./recipe-copy-from.vue?vue&type=template&id=9d2b9bb2&scoped=true"
import script from "./recipe-copy-from.vue?vue&type=script&lang=js"
export * from "./recipe-copy-from.vue?vue&type=script&lang=js"

import "./recipe-copy-from.vue?vue&type=style&index=0&id=9d2b9bb2&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d2b9bb2"]])

export default __exports__